export default "<ion-app>\n  <ion-content>\n    <router-outlet></router-outlet>\n  </ion-content>\n</ion-app>\n";